export default __webpack_public_path__ + "static/datelabel-dropdown-dont-1-light-879d47ee9ea90ed041c85836e2f99ec6.png";